<template>
    <div class="sparator fixed  top-0  border-b-4 border-green-600"></div>
    <!-- <div class="sparator fixed  border-b-4 border-green-600"></div> -->
</template>
<script>
export default {
    mounted() {
        console.log("Component mounted.");
    }
};
</script>
